import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const footerLinks = {
  explore: [
    { label: '热门推荐', href: '/' },
    { label: '最新更新', href: '/' },
    { label: '完结漫画', href: '/' },
    { label: '排行榜', href: '/' },
  ],
  categories: categories.slice(0, 6).map((c) => ({
    label: c.name,
    href: `/category/${c.slug}`,
  })),
  about: [
    { label: '关于我们', href: '/about' },
    { label: '联系我们', href: '/about#contact' },
    { label: '用户协议', href: '#' },
    { label: '隐私政策', href: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-14">
          <div>
            <Link to="/" className="inline-block">
              <span className="text-3xl md:text-4xl font-heading font-bold text-background-50">
                韩漫大全
              </span>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-xs">
              韩国漫画网——专业的韩漫大全平台，海量免费韩国漫画在线阅读，下拉式阅读，每日更新。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[
                { icon: 'ri-home-4-line', label: '首页', to: '/' },
                { icon: 'ri-stack-line', label: '分类', to: '/category/romance' },
                { icon: 'ri-book-open-line', label: '漫画', to: '/article/comic-1' },
                { icon: 'ri-information-line', label: '关于', to: '/about' },
              ].map((item) => (
                <Link
                  key={item.label}
                  to={item.to}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer"
                  aria-label={item.label}
                >
                  <i className={`${item.icon} text-sm`} />
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-foreground-500 mb-5">
              快速浏览
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.explore.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-foreground-500 mb-5">
              热门分类
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-foreground-500 mb-5">
              关于
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩国漫画网 - 韩漫大全. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
